import { faqs } from '@/mocks/site';

export default function FaqBlock() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.8fr_1.2fr]">
        <div>
          <span className="text-xs font-bold uppercase tracking-widest text-primary-600">FAQ · 常见问题</span>
          <h2 className="mt-1 font-display text-2xl text-ink md:text-3xl">你想知道的，都在这里</h2>
          <p className="mt-3 text-sm leading-relaxed text-ink-600">
            关于「校园爆点」的内容来源、投稿方式与阅读定位，我们整理了大家最常问的几个问题，点开即可查看答案。
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((f) => (
            <details key={f.question} className="group rounded-xl border border-cream-200 bg-white p-4 open:border-primary-200 open:bg-white">
              <summary className="flex cursor-pointer items-center justify-between gap-3 text-sm font-bold text-ink">
                {f.question}
                <span className="faq-arrow flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-600 transition-transform">
                  <i className="ri-add-line" />
                </span>
              </summary>
              <p className="mt-3 border-t border-cream-100 pt-3 text-sm leading-relaxed text-ink-600">
                {f.answer}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}